import { render } from "./TPCommonHeader.vue?vue&type=template&id=0aede682&scoped=true&ts=true"
import script from "./TPCommonHeader.vue?vue&type=script&lang=ts"
export * from "./TPCommonHeader.vue?vue&type=script&lang=ts"

import "./TPCommonHeader.vue?vue&type=style&index=0&id=0aede682&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aede682"]])

export default __exports__